import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import {
  EmailFormInput,
  SMSSettings,
  NotificationTypeGrid,
  emailRegEx,
} from 'ecs-react-components/dist/index.es';
import {
  getReminderSettings,
  getPatientReminderSettings,
  setPatientReminderSettings,
} from '../../redux/modules/reminder-settings/reminder-settings-middleware';
import { messages } from './AccountSettings.i18n';
import { getNotificationGridConfig } from './NotificationGridConfiguration';
import {
  setNotificationEmail,
  updatePatientNotificationFormInput,
} from '../../redux/modules/account-settings/actions/creators';
import * as MsgBarActions from '../../redux/modules/system-shared/message-bar-action-creator';

class PatientNotificationSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isDisplayInvalidEmailMessage: false,
    };
  }

  UNSAFE_componentWillMount = () => {
    this.props.dispatch(getReminderSettings());
    this.props.dispatch(getPatientReminderSettings(this.props.patientId));
  }

  componentDidMount = () => {
    this.props.dispatch(setNotificationEmail(this.props.emailAddress));
  }

  getGridConfiguration = () => {
    const { reminderSettings, patientReminderSettings } = this.props;
    return getNotificationGridConfig(
      reminderSettings,
      patientReminderSettings,
      this.props.intl.formatMessage(messages.notificationTypeGrid.followUpLabel),
      {
        typeLabel: this.props.intl.formatMessage(messages.notificationTypeGrid.appointmentsLabel.typeLabel),
        info: this.props.intl.formatMessage(messages.notificationTypeGrid.appointmentsLabel.info),
      },
      this.props.intl.formatMessage(messages.notificationTypeGrid.secureMessageLabel),
      this.props.intl.formatMessage(messages.notificationTypeGrid.questionnairesLabel),
      this.handleInputChange);
  }

  getEmailAddress() {
    const { patientReminderSettings, notificationEmail } = this.props;
    if (patientReminderSettings && !(patientReminderSettings.usePrimaryEmail)) {
      return patientReminderSettings.nonPrimaryEmailAddress;
    }
    return notificationEmail;
  }

  emailOnChangeHandler = (event) => {
    this.handleInputChange(event.target.name, event.target.value);
    this.props.dispatch(setNotificationEmail(event.target.value));
  }

  handleInputChange = (name, value) => {
    this.props.dispatch(updatePatientNotificationFormInput(name, value));

    if (name === 'nonPrimaryEmailAddress' &&
        this.state.isDisplayInvalidEmailMessage) {
      this.setState({
        isDisplayInvalidEmailMessage: value !== '' && !emailRegEx.test(value),
      });
    }
  }

  saveOnClick = () => {
    const isEmailValid = this.isEmailValid();

    this.setState({
      isDisplayInvalidEmailMessage: !isEmailValid,
    });

    if (isEmailValid && !this.isSmsRequiredFailed() && !this.isEmailRequiredFailed()) {
      this.props.dispatch(setPatientReminderSettings(
        this.props.patientId, this.props.patientReminderSettings));
    } else {
      this.props.dispatch(MsgBarActions.dismissMessage());
    }
  }

  isEmailValid() {
    const { notificationEmail, patientReminderSettings } = this.props;
    const primaryValid = patientReminderSettings.usePrimaryEmail &&
      emailRegEx.test(notificationEmail);
    const nonPrimaryValid = !(patientReminderSettings.usePrimaryEmail) &&
      emailRegEx.test(patientReminderSettings.nonPrimaryEmailAddress);
    return primaryValid || nonPrimaryValid;
  }

  isEmailRequiredFailed() {
    const { patientReminderSettings, emailAddress } = this.props;
    const { reminderSettings } = this.props;

    if ((patientReminderSettings.followUpEmailEnabled && reminderSettings.patientFollowUpEmailEnabled) ||
      (patientReminderSettings.appointmentEmailEnabled && reminderSettings.patientAppointmentEmailEnabled) ||
      (patientReminderSettings.secureMessageEmailEnabled && reminderSettings.patientSecureMessageEmailEnabled) ||
      (patientReminderSettings.questionnaireEmailEnabled && reminderSettings.patientQuestionnaireEmailEnabled)) {
      const primaryEmailIsBlank = patientReminderSettings.usePrimaryEmail && emailAddress === '';
      const nonPrimaryEmailIsBlank = !patientReminderSettings.usePrimaryEmail &&
      patientReminderSettings.nonPrimaryEmailAddress === '';

      if (nonPrimaryEmailIsBlank) {
        return true;
      }

      if (primaryEmailIsBlank) {
        return true;
      }

      return false;
    }
    return false;
  }

  isSmsRequiredFailed() {
    const { patientReminderSettings } = this.props;
    const { reminderSettings } = this.props;

    if ((patientReminderSettings.followUpSmsEnabled && reminderSettings.patientFollowUpSmsEnabled) ||
        (patientReminderSettings.appointmentSmsEnabled && reminderSettings.patientAppointmentSmsEnabled) ||
        (patientReminderSettings.secureMessageSmsEnabled && reminderSettings.patientSecureMessageSmsEnabled) ||
        (patientReminderSettings.questionnaireSmsEnabled && reminderSettings.patientQuestionnaireSmsEnabled)) {
      if (patientReminderSettings.smsPhoneNumber === null ||
        patientReminderSettings.smsPhoneNumber === '') {
        return true;
      }
      return false;
    }
    return false;
  }

  render() {
    if (this.props.reminderSettings === null) {
      return null;
    }

    const gridConfig = this.getGridConfiguration();
    const isDisplayEmailInput = gridConfig.find((x) => x.isEmailEnabled) !== undefined;
    const isDisplaySmsInput = gridConfig.find((x) => x.isSmsEnabled) !== undefined;

    return (
      !isDisplayEmailInput && !isDisplaySmsInput ?
        null :
      <div className="settings-section">
        <h4 className="mt-2"><FormattedMessage {...messages.patientNotificationSettings.title} /></h4>
        <p><FormattedMessage {...messages.patientNotificationSettings.description} /></p>
        <form onChange={this.props.onFormChange}>
          <div className="row">
            <div className="col-sm-4">
              { isDisplayEmailInput ?
                <EmailFormInput
                  id="NotificationEmail"
                  labelText={this.props.intl.formatMessage(messages.patientNotificationSettings.emailLabel)}
                  email={this.getEmailAddress()}
                  onChange={this.emailOnChangeHandler}
                  isDisplayRequiredFailed={this.isEmailRequiredFailed()}
                  isDisplayInvalid={this.state.isDisplayInvalidEmailMessage}
                  emailPropertyName="nonPrimaryEmailAddress"
                /> : null }

              { isDisplaySmsInput ?
                <SMSSettings
                  phonePropertyName="smsPhoneNumber"
                  smsPhoneNumber={this.props.patientReminderSettings.smsPhoneNumber}
                  onInputChange={this.handleInputChange}
                  isDisplayRequiredFailed={this.isSmsRequiredFailed()}
                  intl={this.props.intl}
                /> : null }
            </div>
          </div>
          <h5 className="mb-3">
            <FormattedMessage {...messages.patientNotificationSettings.notificationTypeTitle} />
          </h5>
          <div className="row">
            <div className="col-sm-6 col-lg-4">
              <NotificationTypeGrid rowsConfig={gridConfig} intl={this.props.intl}/>
            </div>
          </div>
          <button type="button" className="btn btn-primary" onClick={this.saveOnClick}>
            <FormattedMessage {...messages.patientNotificationSettings.submitButton} />
          </button>
        </form>
      </div>
    );
  }
}

PatientNotificationSettings.propTypes = {
  dispatch: PropTypes.func.isRequired,
  reminderSettings: PropTypes.object,
  patientReminderSettings: PropTypes.object,
  intl: PropTypes.object,
  patientId: PropTypes.string,
  emailAddress: PropTypes.string,
  notificationEmail: PropTypes.string,
  onFormChange: PropTypes.func,
  reminderSettingsHash: PropTypes.string,
  patientReminderSettingsHash: PropTypes.string,
};

const mapStateToProps = (state) => (
  {
    reminderSettings: state.accountSettings.reminderSettings.reminderSettings,
    reminderSettingsHash: JSON.stringify(state.accountSettings.reminderSettings.reminderSettings),
    patientReminderSettings: state.accountSettings.patientReminderSettings,
    patientReminderSettingsHash: JSON.stringify(state.accountSettings.patientReminderSettings),
    patientId: state.profile.patient.patientId,
    emailAddress: state.profile.patient.emailAddress,
    notificationEmail: state.accountSettings.notificationEmail.email,
  });

export default connect(mapStateToProps)(injectIntl(PatientNotificationSettings));